// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export enum DnaSyngoviaNodeEType {
  AT = 'at',
  SYNGO_VIA = 'syngovia',
  US = 'us',
  CT = 'ct',
  XP_RF = 'xp_rf',
  XP_SU = 'xp_su',
  XP_UR = 'xp_ur',
  XP_WH = 'xp_wh',
  MR = 'mr',
  MI = 'mi',
  PRINTER = 'printer',
  CD_BURNER = 'cd_burner',
  CLIENT = 'client',
  SERVER = 'server',
  RIS = 'ris',
  PACS = 'pacs',
  CUSTOMIZED = 'customized',
  WORKSTATION = 'workstation',
  DICOM_PROXY = 'dicom_proxy',
  OTHER_MODALITIES = 'othermodalities',
  TEAMPLAY = 'teamplay',
}

export type DnaSyngoviaNodeType = DnaSyngoviaNode &
  DnaSyngoviaClientNode &
  DnaSyngoviaModalityNode &
  DnaSyngoviaServerNode;

export type DnaSyngoviaNodesType = DnaSyngoviaNode[] &
  DnaSyngoviaClientNode[] &
  DnaSyngoviaModalityNode[] &
  DnaSyngoviaServerNode[];

export interface DnaSyngoviaNode {
  type: DnaSyngoviaNodeEType;
  serialNumber?: string;
  materialNumber?: number;
  warnings?: string[] | null;
  logicalName?: string;
  product?: string;
  service?: string;
  ip?: string;
  aet?: string;
  hostname?: string;
  port?: number;
  roleType?: string;
  services?: DnaSyngoviaNodeDicomService[] | null;
}

export interface DnaSyngoviaNodeDicomService {
  name?: string;
  aet?: string;
  port?: number;
  storage: string;
}

export interface DnaSyngoviaClientNode extends DnaSyngoviaNode {
  os?: string;
  networkAdapters?: DnaSyngoviaClientNetworkAdapters[];
  videoControllers?: DnaSyngoviaClientVideoControllers[];
  swVersion?: string;
}

export interface DnaSyngoviaClientNetworkAdapters {
  ip?: string;
  networkSpeed?: string;
  networkAdapter?: string;
}

export interface DnaSyngoviaClientVideoControllers {
  driverVersion?: string;
  driverDate?: string;
  deviceId?: string;
  displayControllers?: DnaSyngoviaClientDisplayControllers[];
}

export interface DnaSyngoviaClientDisplayControllers {
  monitorResolution?: string;
  device?: string;
  deviceString?: string;
  isPrimary?: string;
}

export interface DnaSyngoviaModalityNode extends DnaSyngoviaNode {
  modelName?: string;
}

export interface DnaSyngoviaServerNode extends DnaSyngoviaNode {
  handover?: string;
  msl?: string;
  swVersion?: string;
  virtual?: string;
  hpSn?: string;
  sku?: string;
  systemModel?: string;
  role?: string;
  healthcheckTotalScore?: number;
  iloIp?: string;
  networkAdapters?: DnaSyngoviaServerNetworkAdapters[];
}

export interface DnaSyngoviaServerNetworkAdapters {
  ip?: string;
  dns?: string;
  subnet?: string;
  gateway?: string;
}
